'use client';

import type { UserStreamChoices } from '@/types';
import { createContext, useState, useMemo, type SetStateAction, type Dispatch } from 'react';

export interface MediaContextType {
  userChoices: UserStreamChoices;
  setUserChoices: Dispatch<SetStateAction<UserStreamChoices>>;
}

export const MediaContext = createContext<MediaContextType>({
  userChoices: {} as UserStreamChoices,
  setUserChoices: () => {},
});

export const MediaProvider = ({ children }: { children: React.ReactNode }) => {
  const [userChoices, setUserChoices] = useState<UserStreamChoices>({} as UserStreamChoices);

  const value = useMemo(() => ({ userChoices, setUserChoices }), [userChoices]);

  return <MediaContext.Provider value={value}>{children}</MediaContext.Provider>;
};
